import { useId } from 'react';
import AuthFlowLayout from './AuthFlowLayout';
import PrimaryActionButton from './PrimaryActionButton';
import PodcastFlipper from './PodcastFlipper';
import './OnboardingLoading.css';

export default function OnboardingLoading({ error = null, onRetry }) {
    const titleId = useId();

    return (
        <AuthFlowLayout className='onboardingLoading' logoInteractive={false}>
            <section aria-labelledby={titleId}>
                {error ? (
                    <div className='onboardingLoadingError'>
                        <h1 id={titleId} className='authFlowTitle onboardingLoadingTitle'>
                            Let’s try again
                        </h1>
                        <p className='onboardingLoadingErrorMessage' role='alert'>
                            {error}
                        </p>
                        <PrimaryActionButton
                            type='button'
                            className='onboardingLoadingRetry'
                            onClick={onRetry}
                        >
                            Try again
                        </PrimaryActionButton>
                    </div>
                ) : (
                    <>
                        <div className='onboardingLoadingStatus'>
                            <h1 id={titleId} className='authFlowTitle onboardingLoadingTitle'>
                                Finding your highlights
                            </h1>
                            <p className='authFlowSubtitle'>
                                Picking highlights from the people you chose.
                            </p>
                        </div>
                        <PodcastFlipper embedded />
                    </>
                )}
            </section>
        </AuthFlowLayout>
    );
}
